import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-no-stores',
    template: `
        <h2 style="display: flex; font-size: x-large; justify-content: center;">
            No stores found. Please try again or contact McLane Helpdesk.
        </h2>
    `
})
export class NoStoresComponent implements OnInit {
    path: string;

    constructor() {
    }

    ngOnInit() {
    }
}
